// Dials
import DialBlack from "../images/customisation-assets/Dial_Black.png";
import DialSteel from "../images/customisation-assets/Dial_Steel.png";
import DialBlue from "../images/customisation-assets/Dial_Blue.png";
import DialGreen from "../images/customisation-assets/Dial_Green.png";
import DialOrange from "../images/customisation-assets/Dial_Orange.png";
import DialRed from "../images/customisation-assets/Dial_Red.png";
import DialSand from "../images/customisation-assets/Dial_Sand.png";
import DialAqua from "../images/customisation-assets/Dial_Aqua.png";
import DialWhite from "../images/customisation-assets/Dial_White.png";
import DialBlackPink from "../images/customisation-assets/Dial_Black_Pink.png";
import DialNavyYellow from "../images/customisation-assets/Dial_Navy_Yellow.png";
import DialNavyAqua from "../images/customisation-assets/Dial_Navy_Aqua.png";
import DialBlackOrange from "../images/customisation-assets/Dial_Black_Orange.png";
import DialBlackYellow from "../images/customisation-assets/Dial_Black_Yellow.png";
import DialBlackRed from "../images/customisation-assets/Dial_Black_Red.png";
import DialAquaRed from "../images/customisation-assets/Dial_Aqua_Red.png";
import DialBlackGreen from "../images/customisation-assets/Dial_Black_Green.png";
import DialBlackGold from "../images/customisation-assets/Dial_Black_Gold.png";
import DialBlackWhite from "../images/customisation-assets/Dial_Black_White.png";

// Thumbnails
import DialWhiteThumb from "../images/customisation-asset-thumbnails/Dial_White_50x50.png";
import DialGreenThumb from "../images/customisation-asset-thumbnails/Dial_Green_50x50.png";
import DialAquaThumb from "../images/customisation-asset-thumbnails/Dial_Aqua_50x50.png";
import DialOrangeThumb from "../images/customisation-asset-thumbnails/Dial_Orange_50x50.png";
import DialBlueThumb from "../images/customisation-asset-thumbnails/Dial_Blue_50x50.png";
import DialSteelThumb from "../images/customisation-asset-thumbnails/Dial_Silver_50x50.png";
import DialRedThumb from "../images/customisation-asset-thumbnails/Dial_Orange_Full_50x50.png";
import DialSandThumb from "../images/customisation-asset-thumbnails/Dial_Sand_50x50.png";
import DialBlackThumb from "../images/customisation-asset-thumbnails/Dial_Black_50x50.png";
import DialBlackPinkThumb from "../images/customisation-asset-thumbnails/Dial_Black_Pink_50x50.png";
import DialNavyYellowThumb from "../images/customisation-asset-thumbnails/Dial_Navy_Yellow_50x50.png";
import DialNavyAquaThumb from "../images/customisation-asset-thumbnails/Dial_Navy_Aqua_50x50.png";
import DialBlackOrangeThumb from "../images/customisation-asset-thumbnails/Dial_Black_Orange_50x50.png";
import DialBlackYellowThumb from "../images/customisation-asset-thumbnails/Dial_Black_Yellow_50x50.png";
import DialBlackRedThumb from "../images/customisation-asset-thumbnails/Dial_Black_Red_50x50.png";
import DialAquaRedThumb from "../images/customisation-asset-thumbnails/Dial_Aqua_Red_50x50.png";
import DialBlackGreenThumb from "../images/customisation-asset-thumbnails/Dial_Black_Green_50x50.png";
import DialBlackGoldThumb from "../images/customisation-asset-thumbnails/Dial_Black_Gold_50x50.png";
import DialBlackWhiteThumb from "../images/customisation-asset-thumbnails/Dial_Black_White_50x50.png";

import { SelectionColours } from "./selection-colors";

export const DIAL_OPTIONS = {
  steel: {
    title: "Steel & Black",
    watchLayerAsset: DialSteel,
    watchLayerThumbnail: DialSteelThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.STEEL, SelectionColours.BLACK],
    },
  },
  blue: {
    title: "Blue & White",
    watchLayerAsset: DialBlue,
    watchLayerThumbnail: DialBlueThumb,
    selectionAsset: {
      type: "color",
      colors: ["#152A55", SelectionColours.WHITE],
    },
  },
  green: {
    title: "Green & Red",
    watchLayerAsset: DialGreen,
    watchLayerThumbnail: DialGreenThumb,
    selectionAsset: {
      type: "color",
      colors: ["#59612E", SelectionColours.RED],
    },
  },
  orange: {
    title: "Orange & Black",
    watchLayerAsset: DialOrange,
    watchLayerThumbnail: DialOrangeThumb,
    selectionAsset: {
      type: "color",
      colors: ["#FF6400", SelectionColours.BLACK],
    },
  },
  red: {
    title: "Red & Black",
    watchLayerAsset: DialRed,
    watchLayerThumbnail: DialRedThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.RED, SelectionColours.BLACK],
    },
  },
  sand: {
    title: "Sand & Brown",
    watchLayerAsset: DialSand,
    watchLayerThumbnail: DialSandThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.SAND, SelectionColours.BROWN],
    },
  },
  aqua: {
    title: "Black & Aqua",
    watchLayerAsset: DialAqua,
    watchLayerThumbnail: DialAquaThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.AQUA],
    },
  },
  black: {
    title: "Black & White",
    watchLayerAsset: DialBlack,
    watchLayerThumbnail: DialBlackThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.WHITE],
    },
  },
  white: {
    title: "White & Black",
    watchLayerAsset: DialWhite,
    watchLayerThumbnail: DialWhiteThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.WHITE, SelectionColours.BLACK],
    },
  },

  blackPink: {
    title: "Black & Pink",
    watchLayerAsset: DialBlackPink,
    watchLayerThumbnail: DialBlackPinkThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.PINK],
    },
  },
  navyYellow: {
    title: "Navy & Yellow",
    watchLayerAsset: DialNavyYellow,
    watchLayerThumbnail: DialNavyYellowThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.NAVY, SelectionColours.YELLOW],
    },
  },
  navyAqua: {
    title: "Navy & Aqua",
    watchLayerAsset: DialNavyAqua,
    watchLayerThumbnail: DialNavyAquaThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.NAVY, SelectionColours.AQUA],
    },
  },
  blackOrange: {
    title: "Black & Orange",
    watchLayerAsset: DialBlackOrange,
    watchLayerThumbnail: DialBlackOrangeThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.ORANGE],
    },
  },
  blackYellow: {
    title: "Black & Yellow",
    watchLayerAsset: DialBlackYellow,
    watchLayerThumbnail: DialBlackYellowThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.YELLOW],
    },
  },
  blackRed: {
    title: "Black & Red",
    watchLayerAsset: DialBlackRed,
    watchLayerThumbnail: DialBlackRedThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.RED],
    },
  },
  aquaRed: {
    title: "Aqua & Red",
    watchLayerAsset: DialAquaRed,
    watchLayerThumbnail: DialAquaRedThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.AQUA, SelectionColours.RED],
    },
  },
  blackGreen: {
    title: "Black & Green",
    watchLayerAsset: DialBlackGreen,
    watchLayerThumbnail: DialBlackGreenThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.FOREST_GREEN],
    },
  },
  blackGold: {
    title: "Black & Gold",
    watchLayerAsset: DialBlackGold,
    watchLayerThumbnail: DialBlackGoldThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.GOLD],
    },
  },
  blackWhite: {
    title: "Black & White",
    watchLayerAsset: DialBlackWhite,
    watchLayerThumbnail: DialBlackWhiteThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.WHITE],
    },
  },
};
